import { render, staticRenderFns } from "./MainProjectSchematicDeviceDetails.vue?vue&type=template&id=5d025a07&scoped=true&"
import script from "./MainProjectSchematicDeviceDetails.vue?vue&type=script&lang=ts&"
export * from "./MainProjectSchematicDeviceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./MainProjectSchematicDeviceDetails.vue?vue&type=style&index=0&id=5d025a07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d025a07",
  null
  
)

export default component.exports